export default {"src":"/_next/static/media/B2BBanner.42538e90.svg","height":414,"width":552};